import React from 'react';
import { ChevronDown } from 'lucide-react';

/** Tahsis / ProfileCard ile aynı kart başlığı: ikon kutusu + text-sm md:text-lg başlık */
export const SectionHeader = ({
  icon: Icon,
  label,
  subtitle,
  right,
  color = 'bg-blue-100 dark:bg-blue-900/30',
  className = 'mb-5',
}) => (
  <div className={`flex items-center gap-2 md:gap-3 ${className}`}>
    {Icon && (
      <div
        className={`flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl ${color} shrink-0`}
      >
        <Icon size={18} className="text-blue-600 dark:text-blue-200 md:w-5 md:h-5" />
      </div>
    )}
    {label && (
      subtitle ? (
        <div className="min-w-0 text-left">
          <h3 className="text-sm md:text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
            {label}
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</p>
        </div>
      ) : (
        <h3 className="text-sm md:text-lg font-semibold tracking-tight text-gray-900 dark:text-white truncate min-w-0">
          {label}
        </h3>
      )
    )}
    <div className="flex-1 min-w-2" />
    {right && <div className="shrink-0">{right}</div>}
  </div>
);

/** Kart içi katlanır panel (Add Rule, Rule Guide vb.) */
export const CollapsiblePanel = ({
  icon: Icon,
  title,
  subtitle,
  expanded,
  onToggle,
  children,
  color = 'bg-blue-100 dark:bg-blue-900/30',
  headerRight,
}) => (
  <div className="rounded-xl border border-gray-100 dark:border-white/5 bg-white dark:bg-[#1C1C1E] overflow-hidden shadow-sm">
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center gap-2 md:gap-3 px-3 md:px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-white/[0.03] transition-colors"
    >
      {Icon && (
        <div
          className={`flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-lg md:rounded-xl ${color} shrink-0`}
        >
          <Icon size={16} className="text-blue-600 dark:text-blue-200 md:w-[18px] md:h-[18px]" />
        </div>
      )}
      <div className="min-w-0 flex-1 text-left">
        <p className="text-sm md:text-base font-semibold text-gray-900 dark:text-white">{title}</p>
        {subtitle && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 leading-relaxed">{subtitle}</p>
        )}
      </div>
      {headerRight && <div className="shrink-0">{headerRight}</div>}
      <ChevronDown
        size={16}
        className={`text-gray-400 shrink-0 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
      />
    </button>
    {expanded && children != null && (
      <div className="px-3 md:px-4 pb-4 border-t border-gray-100 dark:border-white/5 pt-3 md:pt-4">
        {children}
      </div>
    )}
  </div>
);

export default SectionHeader;
